import type { MemberDetailsParams } from '../services/members.service'

/**
 * Members TanStack query key factory — keep in sync with members.query-store usage.
 */
export const membersQueryKeys = {
  all: (groupId?: string) => ['members', groupId] as const,
  list: (groupId: string, locationId: string, filters?: string[]) => ['members', groupId, locationId, 'list', filters] as const,
  details: (groupId: string, params?: MemberDetailsParams) => ['members', groupId, 'details', params] as const,
  requestCount: (groupId: string, locationId: string) => ['members', groupId, locationId, 'request-count'] as const,
  channelSuggestions: (groupId: string | undefined, channelId: string, params?: Record<string, unknown>) =>
    ['members', groupId, 'channel-suggestions', channelId, params] as const,
  membershipForm: (groupId: string | undefined, formId: string) => ['members', groupId, 'membership-form', formId] as const,
  infinite: (groupId: string | undefined, params?: Partial<MemberDetailsParams>) =>
    [
      'members',
      groupId,
      'infinite',
      params?.search ?? '',
      params?.showEmail ?? false,
      params?.memberRole ?? '',
      params?.memberStatus ?? '',
    ] as const,
} as const
